 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import HALFTITLE from '@/components/halftitle'
 import TITLE from '@/components/title'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import ACKNOWLEDGEMENTS from '@/components/acknowledgements'
 import INTRODUCTION from '@/components/introduction'
 import CH1 from '@/components/ch1'
 import CH2 from '@/components/ch2'
 import CH3 from '@/components/ch3'
 import CH4 from '@/components/ch4'
 import CH5 from '@/components/ch5'
 import CH6 from '@/components/ch6'
 import CH7 from '@/components/ch7'
 import CH8 from '@/components/ch8'
 import CH9 from '@/components/ch9'
 import CH10 from '@/components/ch10'
 import CH11 from '@/components/ch11'
 import CH12 from '@/components/ch12'
 import CH13 from '@/components/ch13'
 import CH14 from '@/components/ch14'
 import ABOUTTHEAUTHOR from '@/components/abouttheauthor'
 import BM from '@/components/bm'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/acknowledgements",
 			"name" : "acknowledgements",
 			"component" : ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/introduction",
 			"name" : "introduction",
 			"component" : INTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js